import { useState } from "react";
import { C } from '../constants';

const COLLAPSED_W = 52;
const EXPANDED_W  = 220;

export default function Sidebar({ tab, setTab, nav, data, catalogStats, syncCatalog, syncOrders, syncOrdersLoading, onLogout, onSettings, onAdmin, hasCredentials, balance, isMobile, mobileOpen, onMobileClose }) {
  const [collapsed, setCollapsed] = useState(() => {
    try { return localStorage.getItem("sidebar_collapsed") === "1"; } catch { return false; }
  });

  const toggle = () => {
    if (isMobile) { onMobileClose?.(); return; }
    setCollapsed(c => {
      const next = !c;
      try { localStorage.setItem("sidebar_collapsed", next ? "1" : "0"); } catch {}
      return next;
    });
  };

  const w = isMobile ? EXPANDED_W : (collapsed ? COLLAPSED_W : EXPANDED_W);
  const hiddenOnMobile = isMobile && !mobileOpen;

  return (
    <>
    {isMobile && mobileOpen && <div className="crm-sidebar-overlay" onClick={onMobileClose} />}
    <div
      className={`crm-sidebar${hiddenOnMobile ? " sidebar-hidden" : ""}`}
      style={{
        width: w, background: C.bg1,
        borderRight: `1px solid ${C.border}`,
        height: "100vh", flexShrink: 0,
        display: "flex", flexDirection: "column",
        boxShadow: "2px 0 32px rgba(0,0,0,.4)",
        transition: "width .2s ease, transform .25s ease",
        overflow: "hidden",
      }}>

      {/* Logo + toggle */}
      <div style={{ padding: collapsed ? "18px 0 14px" : "18px 18px 14px", display: "flex", alignItems: "center", justifyContent: collapsed ? "center" : "space-between" }}>
        {!collapsed && (
          <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0 }}>
            <div style={{
              width: 32, height: 32, borderRadius: 10, flexShrink: 0,
              background: `linear-gradient(135deg, ${C.blue}40, ${C.green}30)`,
              border: `1px solid ${C.blue}35`,
              display: "flex", alignItems: "center", justifyContent: "center",
              boxShadow: `0 0 16px ${C.blue}20`,
            }}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <rect x="1" y="1" width="6" height="6" rx="1.5" fill={C.blue} opacity="0.9"/>
                <rect x="9" y="1" width="6" height="6" rx="1.5" fill={C.green} opacity="0.7"/>
                <rect x="1" y="9" width="6" height="6" rx="1.5" fill={C.purple} opacity="0.7"/>
                <rect x="9" y="9" width="6" height="6" rx="1.5" fill={C.blue} opacity="0.5"/>
              </svg>
            </div>
            <div>
              <div style={{ fontSize: 14, fontWeight: 800, color: C.text1, letterSpacing: "-0.4px", lineHeight: 1.1 }}>Likvix</div>
              <div style={{ fontSize: 9, color: C.text4, letterSpacing: "1px", fontWeight: 600, textTransform: "uppercase", marginTop: 1 }}>Seller Analytics</div>
            </div>
          </div>
        )}
        {collapsed && (
          <div style={{
            width: 32, height: 32, borderRadius: 10,
            background: `linear-gradient(135deg, ${C.blue}40, ${C.green}30)`,
            border: `1px solid ${C.blue}35`,
            display: "flex", alignItems: "center", justifyContent: "center",
            boxShadow: `0 0 16px ${C.blue}20`,
          }}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <rect x="1" y="1" width="6" height="6" rx="1.5" fill={C.blue} opacity="0.9"/>
              <rect x="9" y="1" width="6" height="6" rx="1.5" fill={C.green} opacity="0.7"/>
              <rect x="1" y="9" width="6" height="6" rx="1.5" fill={C.purple} opacity="0.7"/>
              <rect x="9" y="9" width="6" height="6" rx="1.5" fill={C.blue} opacity="0.5"/>
            </svg>
          </div>
        )}
        {!collapsed && (
          <button onClick={toggle} title="Згорнути" style={{
            background: "transparent", border: "none", cursor: "pointer",
            color: C.text4, fontSize: 16, padding: "2px 4px", lineHeight: 1,
            borderRadius: 6, flexShrink: 0,
          }}
            onMouseEnter={e => e.currentTarget.style.color = C.text2}
            onMouseLeave={e => e.currentTarget.style.color = C.text4}
          >‹</button>
        )}
      </div>

      {collapsed && (
        <button onClick={toggle} title="Розгорнути" style={{
          background: "transparent", border: "none", cursor: "pointer",
          color: C.text4, fontSize: 16, padding: "4px 0", lineHeight: 1,
          width: "100%", textAlign: "center", marginBottom: 4,
        }}
          onMouseEnter={e => e.currentTarget.style.color = C.text2}
          onMouseLeave={e => e.currentTarget.style.color = C.text4}
        >›</button>
      )}

      <div style={{ height: 1, background: `linear-gradient(90deg, transparent, ${C.border}, transparent)`, margin: "0 10px 8px" }} />

      {/* Navigation */}
      <div style={{ flex: 1, paddingTop: 4, paddingBottom: 4 }}>
        {nav.map(n => {
          const active = tab === n.id;
          return (
            <a key={n.id} href={`/${n.id}`} title={collapsed ? n.label : undefined}
              onClick={e => { if (!e.ctrlKey && !e.metaKey && e.button !== 1) { e.preventDefault(); setTab(n.id); } }}
              style={{
                display: "flex", alignItems: "center", gap: collapsed ? 0 : 9,
                margin: "2px 6px",
                padding: collapsed ? "9px 0" : "9px 12px",
                justifyContent: collapsed ? "center" : "flex-start",
                cursor: "pointer", fontSize: 13, fontWeight: active ? 600 : 500,
                color: active ? C.text1 : C.text3,
                background: active ? `${C.blue}18` : "transparent",
                borderRadius: 10,
                transition: "all .15s",
                position: "relative",
                textDecoration: "none",
              }}
              onMouseEnter={e => { if (!active) { e.currentTarget.style.background = C.bg3; e.currentTarget.style.color = C.text2; } }}
              onMouseLeave={e => { e.currentTarget.style.background = active ? `${C.blue}18` : "transparent"; e.currentTarget.style.color = active ? C.text1 : C.text3; }}
            >
              {active && (
                <div style={{
                  position: "absolute", left: 0, top: "18%", bottom: "18%",
                  width: 3, borderRadius: "0 3px 3px 0",
                  background: `linear-gradient(180deg, ${C.blue}aa, ${C.blue})`,
                  boxShadow: `0 0 8px ${C.blue}60`,
                }} />
              )}
              <span style={{ fontSize: 14, opacity: active ? 1 : 0.5, lineHeight: 1, width: 18, textAlign: "center", flexShrink: 0 }}>{n.icon}</span>
              {!collapsed && <span style={{ flex: 1 }}>{n.label}</span>}
              {!collapsed && n.badge > 0 && (
                <span style={{
                  background: n.id === "trending" ? `${C.green}22` : `${C.pink}22`,
                  color: n.id === "trending" ? C.green : C.pink,
                  borderRadius: 10, padding: "1px 7px", fontSize: 10, fontWeight: 700,
                  border: `1px solid ${n.id === "trending" ? C.green : C.pink}30`,
                }}>{n.badge}</span>
              )}
              {collapsed && n.badge > 0 && (
                <div style={{
                  position: "absolute", top: 6, right: 6,
                  width: 7, height: 7, borderRadius: "50%",
                  background: n.id === "trending" ? C.green : C.pink,
                }} />
              )}
            </a>
          );
        })}
      </div>

      {/* Footer — hidden when collapsed */}
      {!collapsed && (
        <div style={{ padding: "12px 12px 16px", borderTop: `1px solid ${C.border}` }}>
          {balance && <BalanceCard balance={balance} />}
          {(data?.last_synced || catalogStats) && (
            <div style={{ background: C.bg0, borderRadius: 8, padding: "7px 10px", marginBottom: 8, border: `1px solid ${C.border}` }}>
              {data?.last_synced && (
                <div style={{ fontSize: 10, color: C.text4, lineHeight: 1.6 }}>
                  Замовлення: {new Date(data.last_synced).toLocaleTimeString("uk")}
                </div>
              )}
              {catalogStats && (
                <div style={{ fontSize: 10, color: C.text4, lineHeight: 1.6 }}>
                  Каталог: {catalogStats.catalog_synced || 0}/{catalogStats.total_products || 0}
                  {catalogStats.last_sync && (
                    <span> · {new Date(catalogStats.last_sync).toLocaleString("uk", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" })}</span>
                  )}
                </div>
              )}
            </div>
          )}
          {!hasCredentials && (
            <div style={{ background: `${C.yellow}12`, border: `1px solid ${C.yellow}35`, borderRadius: 8, padding: "7px 10px", marginBottom: 8, fontSize: 11, color: C.yellow }}>
              ⚠ API ключі не налаштовані
            </div>
          )}
          <SideBtn onClick={syncOrders} disabled={syncOrdersLoading} color={C.green}>
            {syncOrdersLoading ? "⏳ Синхронізація..." : "↻ Синхр. замовлення"}
          </SideBtn>
          <SideBtn onClick={syncCatalog} color={C.blue}>↻ Синхр. каталог</SideBtn>
          {onAdmin && <SideBtn onClick={onAdmin} color={C.yellow}>⚙ Адмін-панель</SideBtn>}
          {onSettings && <SideBtn onClick={onSettings} color={C.text3}>⚙ Налаштування</SideBtn>}
          {onLogout && <SideBtn onClick={onLogout} color={C.text3}>Вийти</SideBtn>}
        </div>
      )}

      {/* Collapsed footer — just logout icon */}
      {collapsed && (
        <div style={{ padding: "8px 0 12px", borderTop: `1px solid ${C.border}`, display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
          {onLogout && (
            <button onClick={onLogout} title="Вийти" style={{
              background: "transparent", border: "none", cursor: "pointer",
              color: C.text4, fontSize: 14, padding: "6px",
              borderRadius: 8, lineHeight: 1,
            }}
              onMouseEnter={e => e.currentTarget.style.color = C.pink}
              onMouseLeave={e => e.currentTarget.style.color = C.text4}
            >⏻</button>
          )}
        </div>
      )}
    </div>
    </>
  );
}

function fmtBalUAH(v) {
  if (v == null) return "0 ₴";
  const n = Math.abs(Number(v));
  return n.toLocaleString("uk", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " ₴";
}

function BalanceCard({ balance }) {
  const content = balance?.content || {};
  const bal = content.balance || {};
  const total = bal.total ?? null;
  const daysToBlock = content.count_days_to_lock ?? null;

  const isDebt = total != null && total < 0;
  const blockColor = daysToBlock == null ? C.text4 : daysToBlock <= 3 ? C.pink : daysToBlock <= 7 ? C.yellow : C.green;

  const rows = [
    { l: "Роялті",             v: bal.royalty },
    { l: "Логістика",          v: bal.logistic },
    { l: "Реклама",            v: bal.advertising },
    { l: "Річ контент",        v: bal.rich_content },
    { l: "Акції (Нова Пошта)", v: bal.promotional },
    { l: "Підписка Smart",     v: bal.premium },
  ];

  return (
    <div style={{ background: C.bg0, borderRadius: 8, padding: "8px 10px", marginBottom: 8, border: `1px solid ${isDebt ? C.pink + "40" : C.border}` }}>
      <div style={{ fontSize: 9, color: C.text4, textTransform: "uppercase", letterSpacing: "0.8px", fontWeight: 700, marginBottom: 5 }}>Баланс Rozetka</div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 3 }}>
        <span style={{ fontSize: 11, fontWeight: 700, color: C.text2 }}>{isDebt ? "Заборгованість:" : "Профіцит:"}</span>
        <span style={{ fontSize: 13, fontWeight: 800, color: isDebt ? C.pink : C.green, letterSpacing: "-0.3px" }}>{fmtBalUAH(Math.abs(total ?? 0))}</span>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", fontSize: 10, color: C.text4, marginBottom: 1 }}>
        <span>Гарантійний платіж</span><span>{fmtBalUAH(bal.consolidated ?? 0)}</span>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", fontSize: 10, color: C.text4, marginBottom: 6 }}>
        <span>Сіра зона</span><span>{fmtBalUAH(bal.royalty_gray ?? 0)}</span>
      </div>
      {rows.map(r => (
        <div key={r.l} style={{ display: "flex", justifyContent: "space-between", fontSize: 10, color: C.text4, marginBottom: 1 }}>
          <span>{r.l}</span>
          <span style={{ color: (r.v ?? 0) !== 0 ? C.pink : C.text4 }}>{fmtBalUAH(r.v ?? 0)}</span>
        </div>
      ))}
      {daysToBlock != null && (
        <div style={{ marginTop: 6, fontSize: 10, color: blockColor, fontWeight: 600 }}>
          {daysToBlock <= 0 ? "⛔ Акаунт заблоковано!" : `⏰ ${daysToBlock} дн. до блокування`}
        </div>
      )}
    </div>
  );
}

function SideBtn({ onClick, disabled, color, children }) {
  return (
    <button onClick={onClick} disabled={disabled} style={{
      width: "100%", padding: "7px 10px", borderRadius: 9, marginBottom: 5,
      background: "transparent", border: `1px solid ${C.border}`,
      color: disabled ? `${color}80` : color,
      cursor: disabled ? "default" : "pointer",
      fontSize: 11.5, fontWeight: 500,
      transition: "all .15s", textAlign: "left",
    }}
      onMouseEnter={e => { if (!disabled) e.currentTarget.style.background = C.bg3; }}
      onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}
    >{children}</button>
  );
}
